export const centerChildren = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}
